<template>
  <div>
    <!-- 头部 -->
    <top></top>

    <div class="main">
      <navMenu></navMenu>
      <div class="content">
        <div class="header_main">
          <div class="header_title">
            {{ itemdata.name }}（适用于品牌方和工厂企业）
          </div>
          <div class="header_step_box">
            <div class="step_item">
              <div
                class="step_number"
                :class="titltshowlist.indexOf(1) !== -1 ? 'step_actitive' : ''"
              >
                1
              </div>
              <div class="step_txt">
                <div class="txt1">填写基本信息</div>
                <div
                  class="txt2"
                  :class="titltshowlist.indexOf(1) !== -1 ? 'txt_actitive' : ''"
                >
                  填写或确认基本信息
                </div>
              </div>
            </div>
            <div class="step_item">
              <div
                class="step_number"
                :class="titltshowlist.indexOf(2) !== -1 ? 'step_actitive' : ''"
              >
                2
              </div>
              <div class="step_txt">
                <div class="txt1">填写产品信息</div>
                <div
                  class="txt2"
                  :class="titltshowlist.indexOf(2) !== -1 ? 'txt_actitive' : ''"
                >
                  填写产品信息
                </div>
              </div>
            </div>
            <!--<div class="step_item" v-if="templateTpye==1">-->
            <!--<div class="step_number" :class="titltshowlist.indexOf(3)!==-1?'step_actitive':''">3</div>-->
            <!--<div class="step_txt">-->
            <!--<div class="txt1">完成报名</div>-->
            <!--<div class="txt2" :class="titltshowlist.indexOf(3)!==-1?'txt_actitive':''">补充信息完成报名</div>-->
            <!--</div>-->
            <!--</div>-->
          </div>
        </div>
        <div class="content_main">
          <div class="content_main_title" v-if="titleshow == 1">
            参选企业基本信息
            <div class="edit-wrap" @click="editCompany">
              <img
                class="edit-icon"
                src="../../assets/discussion/dis_icon02.png"
              />修改
            </div>
          </div>
          <div class="content_main_title" v-if="titleshow == 2">
            参选产品信息
            <div class="edit-wrap" @click="editProduct">
              <img
                class="edit-icon"
                src="../../assets/discussion/dis_icon02.png"
              />修改
            </div>
          </div>
          <div class="content_main_title" v-if="titleshow == 3">
            参选产品信息上传
            <!--   <div class="edit-wrap">-->
            <!--    <img class="edit-icon" @click="editCompany" src="../images/dis_icon02.png" >修改-->
            <!--</div>-->
          </div>
          <!--第一步 填写基本信息-->
          <el-form
            v-show="titleshow == 1"
            :model="companyForm"
            ref="companyForm"
            :rules="companyFormRules"
            label-width="90px"
            class="demo-ruleForm"
            label-position="top"
          >
            <el-row>
              <el-col :span="7">
                <el-form-item label="公司名称：" prop="companyName">
                  <el-input
                    v-model="companyForm.companyName"
                    placeholder="请输入"
                    disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="展位号：" prop="boothNo">
                  <el-input
                    v-model="companyForm.boothNo"
                    placeholder="请输入"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="展区：" prop="exhibitionArea">
                  <el-input
                    v-model="companyForm.exhibitionArea"
                    placeholder="请输入"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="展馆号：" prop="hallNo">
                  <el-input
                    v-model="companyForm.hallNo"
                    placeholder="请输入"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="联系人：" prop="contacts">
                  <el-input
                    v-model="companyForm.contacts"
                    placeholder="请输入"
                    :disabled="isCompanyEdit"
                  ></el-input>
                  <span style="color: red"
                    >如与货架好物联系人不一致请在此修改</span
                  >
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="手机号：" prop="telephoneNumber">
                  <el-input
                    v-model="companyForm.telephoneNumber"
                    placeholder="请输入"
                    :disabled="isCompanyEdit"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="邮箱：">
                  <el-input
                    v-model="companyForm.email"
                    placeholder="请输入"
                    :disabled="isCompanyEdit"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="联系地址：" prop="address">
                  <el-input
                    v-model="companyForm.address"
                    placeholder="请输入"
                    :disabled="isCompanyEdit"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="公司介绍：">
                  <el-input
                    type="textarea"
                    rows="4"
                    v-model="companyForm.introduction"
                    resize="none"
                    placeholder="请输入"
                    :disabled="isCompanyEdit"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="公司logo：" prop="logo" class="form-width">
                  <div class="image" v-if="companyForm.logo">
                    <el-image :src="$imgOssUrl + companyForm.logo"></el-image>
                    <div class="upload-span">
                      <span
                        class="upload-icon"
                        @click.stop="
                          handlePictureCardPreview(
                            $imgOssUrl + companyForm.logo
                          )
                        "
                        ><i class="el-icon-zoom-in"></i
                      ></span>
                      <span
                        class="upload-icon"
                        @click.stop="handleRemove()"
                        style="margin-left: 20px"
                        ><i class="el-icon-delete"></i
                      ></span>
                    </div>
                  </div>
                  <div v-if="!companyForm.logo">
                    <el-upload
                      :action="$Url"
                      list-type="picture-card"
                      :headers="headers"
                      :multiple="false"
                      :on-progress="handleProgresslogo"
                      :on-success="handleLogoSuccess"
                      :on-error="handleLogoError"
                      :show-file-list="false"
                    >
                      <i class="el-icon-plus" v-if="!progressLogoVisible"></i>
                      <div v-if="progressLogoVisible" style="padding-top: 30px">
                        <el-progress
                                :percentage="progressLogoPercent"
                                type="circle"
                                :width="80"
                        ></el-progress>
                      </div>
                    </el-upload>
                  </div>
                  <div class="img-tips">
                    上传图片接受JPG、PNG格式、图片大小不超过2M,分辨率不小于300dpl
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item class="save_btn">
              <el-button @click="goback">返 回</el-button>
              <el-button type="primary" @click="step_btn_new('companyForm')"
                >下一步</el-button
              >
            </el-form-item>
          </el-form>

          <!-- 产品基本模版表单 -->
          <template v-if="templateTpye == 8">
            <!--同步产品信息-->
            <el-form
              :model="productForm"
              ref="productForm"
              :rules="productFormRules"
              label-width="110px"
              class="demo-ruleForm"
              label-position="top"
              v-if="titleshow == 2"
            >
              <!--<img class="edit-icon" @click="editProduct" src="../images/discussion_edit.jpg" >-->

              <el-row>
                <el-col :span="8">
                  <el-form-item label="产品名称：" prop="goodsName">
                    <el-input
                      v-model="productForm.goodsName"
                      placeholder="请输入产品名称"
                      :disabled="isProductEdit"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="年销售额：" prop="yearSale">
                    <el-input
                      type="text"
                      v-model="productForm.yearSale"
                      placeholder="请输入年销售额"
                      :disabled="isProductEdit"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="产品类别：" prop="nhne_ProductClass">
                    <el-select
                      v-model="productForm.nhne_ProductClass"
                      placeholder="请选择产品类别"
                      popper-class="type-select"
                      style="width: 100%"
                      :disabled="isProductEdit"
                    >
                      <el-option
                        v-for="(item, index) in productlist"
                        :key="index"
                        :label="item.class_name"
                        :value="item.class_name"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="产品标签（限选两项）："
                    prop="newfeatures"
                  >
                    <el-select
                      :disabled="isProductEdit"
                      v-model="productForm.newfeatures"
                      multiple
                      collapse-tags
                      multiple-limit="2"
                      style="width: 100%"
                      placeholder="请选择产品特点(最多两项)"
                    >
                      <el-option
                        v-for="(item, index) in tablist.productAbbr_option"
                        :key="index"
                        :label="item.val"
                        :value="item.val"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="产品简介：" prop="cpintroduction">
                    <el-input
                      type="textarea"
                      v-model="productForm.cpintroduction"
                      rows="4"
                      resize="none"
                      placeholder="须包含与同类产品差异化特点或卖点"
                      :disabled="isProductEdit"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="产品卖点：" prop="advantages">
                    <el-input
                      type="textarea"
                      v-model="productForm.advantages"
                      rows="4"
                      resize="none"
                      placeholder="请输入产品卖点"
                      :disabled="isProductEdit"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="8">
                  <el-form-item label="工艺特点：" prop="characteristic">
                    <el-input
                      type="textarea"
                      v-model="productForm.characteristic"
                      rows="4"
                      resize="none"
                      placeholder="请输入工艺特点"
                      :disabled="isProductEdit"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="产品配料表：" prop="burdenImg">
                    <div class="awards-upload">
                      <el-upload
                        action="/kindeditor/php/uploadApi.php?mode=3"
                        list-type="picture-card"
                        name="imgFile"
                        :before-upload="beforeUpload"
                        :file-list="productForm.burdenImg"
                        accept=".pdf, .png , .jpg, .jepg"
                      >
                        <div slot="file" slot-scope="{ file }">
                          <div>
                            <img
                              class="el-upload-list__item-thumbnail"
                              :src="
                                isPDF(file.url)
                                  ? '../images/pdf_icon.jpg'
                                  : file.url
                              "
                              :style="{
                                maxWidth: isPDF(file.url) ? '75%' : '100%',
                                maxHeight: isPDF(file.url) ? '75%' : '100%',
                              }"
                              alt=""
                            />
                            <span
                              v-if="file.status === 'success'"
                              class="el-upload-list__item-actions"
                            >
                              <span
                                class="el-upload-list__item-preview"
                                @click="handlePreview(file)"
                              >
                                <i class="el-icon-zoom-in"></i>
                              </span>
                              <span
                                class="el-upload-list__item-delete"
                                @click="handleRemove(file)"
                              >
                                <i class="el-icon-delete"></i>
                              </span>
                            </span>
                          </div>
                        </div>
                        <div class="upload-tip">
                          <i>
                            <img
                              class="upload-img"
                              mode="widthFix"
                              src="../../assets/discussion/discussion_upload.jpg"
                            />
                            <div class="tips">请上传PDF或图片</div>
                          </i>
                        </div>
                      </el-upload>
                      <el-dialog :visible.sync="dialogVisible">
                        <img
                          style="
                            max-width: 80%;
                            max-height: 500px;
                            margin: 0 auto;
                          "
                          :src="dialogImageUrl"
                          alt=""
                        />
                      </el-dialog>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="产品图片：" prop="imgs">
                    <el-upload
                      class="tp_update"
                      action="/"
                      name="imgFile"
                      :on-success="handleAvatarPictureSuccess"
                      list-type="picture-card"
                      :show-file-list="false"
                    >
                      <img
                        v-if="cpImgList[0]"
                        :src="Imghttp + cpImgList[0]"
                        class="avatar"
                      />
                      <div class="upload-tip" v-else>
                        <i class="el-icon-plus">
                          <p class="el-icon-tip">请上传高清图片</p>
                        </i>
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item class="save_btn">
                <el-button @click="step_up_btn(titleshow)">上一步</el-button>
                <el-button
                  type="primary"
                  @click="step_product_btn('productForm')"
                  >下一步</el-button
                >
              </el-form-item>
            </el-form>
            <!--产品报告上传-->
            <!--:rules="reportFormRules"-->
            <el-form
              :model="reportForm"
              ref="reportForm"
              label-width="110px"
              class="demo-ruleForm"
              v-if="titleshow == 3"
              label-position="top"
            >
              <el-row></el-row>
              <el-row></el-row>
              <el-row></el-row>
              <el-row></el-row>
              <el-row></el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item label="质检报告：">
                    <div class="awards-upload">
                      <el-upload
                        action="/"
                        list-type="picture-card"
                        name="imgFile"
                        :before-upload="beforeUploadzj"
                        :file-list="reportForm.inspectionReport"
                        accept=".pdf, .png , .jpg, .jepg"
                      >
                        <div slot="file" slot-scope="{ file }">
                          <div>
                            <img
                              class="el-upload-list__item-thumbnail"
                              :src="
                                isPDF(file.url)
                                  ? '../images/pdf_icon.jpg'
                                  : file.url
                              "
                              :style="{
                                maxWidth: isPDF(file.url) ? '75%' : '100%',
                                maxHeight: isPDF(file.url) ? '75%' : '100%',
                              }"
                              alt=""
                            />
                            <span
                              v-if="file.status === 'success'"
                              class="el-upload-list__item-actions"
                            >
                              <span
                                class="el-upload-list__item-preview"
                                @click="handlePreview(file)"
                              >
                                <i class="el-icon-zoom-in"></i>
                              </span>
                              <span
                                class="el-upload-list__item-delete"
                                @click="handlezjRemove(file)"
                              >
                                <i class="el-icon-delete"></i>
                              </span>
                            </span>
                          </div>
                        </div>
                        <div class="upload-tip">
                          <i>
                            <img
                              class="upload-img"
                              mode="widthFix"
                              src="../../assets/discussion/discussion_upload.jpg"
                            />
                            <div class="tips">请上传PDF或图片</div>
                          </i>
                        </div>
                      </el-upload>
                      <el-dialog :visible.sync="dialogVisible">
                        <img
                          style="
                            max-width: 80%;
                            max-height: 500px;
                            margin: 0 auto;
                          "
                          :src="dialogImageUrl"
                          alt=""
                        />
                      </el-dialog>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item label="发明生产专利：">
                    <div class="awards-upload">
                      <el-upload
                        action="/"
                        list-type="picture-card"
                        name="imgFile"
                        :before-upload="beforeUploadfm"
                        :file-list="reportForm.productPatent"
                        accept=".pdf, .png , .jpg, .jepg"
                      >
                        <div slot="file" slot-scope="{ file }">
                          <div>
                            <img
                              class="el-upload-list__item-thumbnail"
                              :src="
                                isPDF(file.url)
                                  ? '../images/pdf_icon.jpg'
                                  : file.url
                              "
                              :style="{
                                maxWidth: isPDF(file.url) ? '75%' : '100%',
                                maxHeight: isPDF(file.url) ? '75%' : '100%',
                              }"
                              alt=""
                            />
                            <span
                              v-if="file.status === 'success'"
                              class="el-upload-list__item-actions"
                            >
                              <span
                                class="el-upload-list__item-preview"
                                @click="handlePreview(file)"
                              >
                                <i class="el-icon-zoom-in"></i>
                              </span>
                              <span
                                class="el-upload-list__item-delete"
                                @click="handlefmscRemove(file)"
                              >
                                <i class="el-icon-delete"></i>
                              </span>
                            </span>
                          </div>
                        </div>
                        <div class="upload-tip">
                          <i>
                            <img
                              class="upload-img"
                              mode="widthFix"
                              src="../../assets/discussion/discussion_upload.jpg"
                            />
                            <div class="tips">请上传PDF或图片</div>
                          </i>
                        </div>
                      </el-upload>
                      <el-dialog :visible.sync="dialogVisible">
                        <img
                          style="
                            max-width: 80%;
                            max-height: 500px;
                            margin: 0 auto;
                          "
                          :src="dialogImageUrl"
                          alt=""
                        />
                      </el-dialog>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item label="历史获奖情况：">
                    <div class="awards-upload">
                      <el-upload
                        accept=".pdf, .png , .jpg, .jepg"
                        action="/kindeditor/php/uploadApi.php?mode=3"
                        list-type="picture-card"
                        name="imgFile"
                        :before-upload="beforeUploadls"
                        :file-list="reportForm.historyAward"
                      >
                        <div slot="file" slot-scope="{ file }">
                          <div>
                            <img
                              class="el-upload-list__item-thumbnail"
                              :src="
                                isPDF(file.url)
                                  ? '../images/pdf_icon.jpg'
                                  : file.url
                              "
                              :style="{
                                maxWidth: isPDF(file.url) ? '75%' : '100%',
                                maxHeight: isPDF(file.url) ? '75%' : '100%',
                              }"
                              alt=""
                            />
                            <span
                              v-if="file.status === 'success'"
                              class="el-upload-list__item-actions"
                            >
                              <span
                                class="el-upload-list__item-preview"
                                @click="handlePreview(file)"
                              >
                                <i class="el-icon-zoom-in"></i>
                              </span>
                              <span
                                class="el-upload-list__item-delete"
                                @click="handlelshjRemove(file)"
                              >
                                <i class="el-icon-delete"></i>
                              </span>
                            </span>
                          </div>
                        </div>
                        <div class="upload-tip">
                          <i>
                            <img
                              class="upload-img"
                              mode="widthFix"
                              src="../../assets/discussion/discussion_upload.jpg"
                            />
                            <div class="tips">请上传PDF或图片</div>
                          </i>
                        </div>
                      </el-upload>
                      <el-dialog :visible.sync="dialogVisible">
                        <img
                          style="
                            max-width: 80%;
                            max-height: 500px;
                            margin: 0 auto;
                          "
                          :src="dialogImageUrl"
                          alt=""
                        />
                      </el-dialog>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <div class="zh_tips1">*签署承诺：（勾选确认生效）</div>
              <div class="zh_tips_checkbox">
                <el-checkbox v-model="checked"
                  ><span
                    >本人经所属企业授权，确认申报参评2024营养星球奖，并承诺通过此页面提交的参评资料真实有效</span
                  ></el-checkbox
                >
              </div>

              <el-form-item class="save_btn">
                <el-button @click="step_up_btn(titleshow)">上一步</el-button>
                <el-button
                  type="primary"
                  @click="saveOnly('reportForm', 1)"
                  :disabled="disableds"
                  >保存并提交</el-button
                >
                <el-button @click="saveOnly('reportForm')" :disabled="disableds"
                  >仅保存</el-button
                >
              </el-form-item>
            </el-form>
          </template>
          <!-- 货架好物报名模版表单 || 选品对接会报名模版表单 -->
          <template
            v-if="templateTpye == 1 || templateTpye == 2 || templateTpye == 3"
          >
            <el-form
              :model="shelfGoodsRuleForm"
              :rules="shelfGoodsRules"
              ref="shelfGoodsRuleForm"
              label-width="180px"
              class="demo-ruleForm"
              label-position="top"
              v-if="titleshow == 2"
            >
              <el-row>
                <el-col :span="8">
                  <el-form-item label="产品名称：" prop="goodsName">
                    <el-input
                      v-model="shelfGoodsRuleForm.goodsName"
                      placeholder="请输入产品名称"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <!--<el-col :span="8">-->
                <!--<el-form-item label="产品类别：" prop="changeproductClass"  v-if="productClass.length>0" >-->
                <!--<el-cascader     @change="handleChange"  v-model="shelfGoodsRuleForm.changeproductClass" style="width: 100%;" :options="productClass" :show-all-levels="false"></el-cascader>-->
                <!--</el-form-item>-->
                <!--</el-col>-->
                <el-col :span="8">
                  <el-form-item label="上市时间：" prop="market_time_new">
                    <el-date-picker
                      style="width: 100%"
                      v-model="shelfGoodsRuleForm.market_time_new"
                      type="date"
                      :picker-options="pickeroptions0"
                    >
                      placeholder="选择上市时间">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    label="产品年销售额(单位:万元)："
                    prop="yearSale"
                  >
                    <el-input
                      v-model="shelfGoodsRuleForm.yearSale"
                      placeholder="仅做渠道对接参考，不对外公布"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="产品零售价(单位:元)："
                    prop="retail_price"
                  >
                    <el-input
                      v-model="shelfGoodsRuleForm.retail_price"
                      placeholder="仅做渠道对接参考，不对外公布"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    label="目前已有主要销售渠道："
                    prop="sales_channel"
                  >
                    <el-input
                      v-model="shelfGoodsRuleForm.sales_channel"
                      placeholder="仅做渠道对接参考，不对外公布"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="希望开拓销售渠道："
                    prop="expand_channels"
                  >
                    <el-input
                      v-model="shelfGoodsRuleForm.expand_channels"
                      placeholder="仅做渠道对接参考，不对外公布"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="产品简介：" prop="introduction">
                    <el-input
                      type="textarea"
                      v-model="shelfGoodsRuleForm.introduction"
                      rows="4"
                      resize="none"
                      placeholder="须包含与同类产品差异化特点或卖点"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item
                    label="产品图片："
                    prop="imgs"
                    class="form-width"
                  >
                    <div class="image" v-if="shelfGoodsRuleForm.imgs">
                      <el-image
                        :src="$imgOssUrl + shelfGoodsRuleForm.imgs"
                      ></el-image>
                      <div class="upload-span">
                        <span
                          class="upload-icon"
                          @click.stop="
                            handlePictureCardPreview(
                              $imgOssUrl + shelfGoodsRuleForm.imgs
                            )
                          "
                          ><i class="el-icon-zoom-in"></i
                        ></span>
                        <span
                          class="upload-icon"
                          @click.stop="handlecpRemove()"
                          style="margin-left: 20px"
                          ><i class="el-icon-delete"></i
                        ></span>
                      </div>
                    </div>
                    <div v-if="!shelfGoodsRuleForm.imgs">
                      <el-upload
                        :action="$Url"
                        list-type="picture-card"
                        :headers="headers"
                        :multiple="false"
                        :on-progress="handleProgressCp"
                        :on-success="handlecpSuccess"
                        :on-error="handlecpError"
                        :show-file-list="false"
                      >
                        <i class="el-icon-plus" v-if="!progressCpVisible"></i>
                        <div v-if="progressCpVisible" style="padding-top: 30px">
                          <el-progress
                                  :percentage="progressCpPercent"
                                  type="circle"
                                  :width="80"
                          ></el-progress>
                        </div>
                      </el-upload>
                    </div>
                    <div class="img-tips">
                      上传图片接受JPG、PNG格式、图片大小不超过2M,分辨率不小于300dpl
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <!--<el-row>-->
              <!--<el-col :span="12">-->
              <!--<el-form-item label="" prop="up_suggestarr">-->
              <!--<span style="color: red;">* </span>货架选择 <span style="color: red;">(请选择最匹配的货架场景，仅限选一项，货架名额满后，主办方将根据货架情况调剂)</span>-->
              <!--<div v-for="(items,index) in dictData.up_suggest" :key="index">-->
              <!--<el-col  :span="24">{{ index }}</el-col>-->
              <!--<el-checkbox-group  v-model="shelfGoodsRuleForm.up_suggestarr"  @change="handleselectionChange">-->
              <!--<el-checkbox v-for="(item,idx) in items" :key="idx" :label="item">{{ item }}</el-checkbox>-->
              <!--</el-checkbox-group>-->
              <!--</div>-->
              <!--<el-col :span="24"><el-checkbox v-model="shelfGoodsRuleForm.up_suggestarr" @change="handleselectionChange" label="其他"></el-checkbox>:(以上都没有，请详细填写)</el-col>-->
              <!--<el-input v-model="hjxz"  v-if="shelfGoodsRuleForm.up_suggestarr.includes('其他')"  placeholder="以上都没有，请详细填写"></el-input>-->
              <!--</el-form-item>-->
              <!--</el-col>-->
              <!--</el-row>-->
              <el-row>
                <el-col :span="12">
                  <el-form-item label="" prop="up_suggest1">
                    <span style="color: red">* </span>货架选择：<span
                      style="color: red"
                      >(请选择最匹配的货架场景，仅限选一项，货架名额满后，主办方将根据货架情况调剂)</span
                    >

                    <el-radio-group
                      v-model="shelfGoodsRuleForm.up_suggest1"
                      @change="handleselectionChange"
                    >
                      <el-radio
                        v
                        v-for="(item, index) in dictData.up_suggest"
                        :key="index"
                        :label="item"
                        >{{ item }}</el-radio
                      >
                    </el-radio-group>

                    <el-col :span="24"
                      ><el-radio
                        v-model="shelfGoodsRuleForm.up_suggest1"
                        @change="handleselectionChange"
                        label="其他"
                      ></el-radio
                      >:(以上都没有，请详细填写)</el-col
                    >
                    <el-input
                      v-model="hjxz"
                      v-if="shelfGoodsRuleForm.up_suggest1 == '其他'"
                      placeholder="以上都没有，请详细填写"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!--极智工场报名  表单-->
              <template v-if="templateTpye == 3">
                <el-row>
                  <el-col :span="16">
                    <el-form-item label="可生产剂型" prop="used_dosagearr">
                      <el-checkbox-group
                        v-model="shelfGoodsRuleForm.used_dosagearr"
                      >
                        <el-checkbox
                          v-for="(item, index) in dictData.used_dosage"
                          :key="index"
                          :label="item"
                        ></el-checkbox>
                      </el-checkbox-group>
                      <el-col :span="24"
                        ><el-checkbox
                          v-model="shelfGoodsRuleForm.used_dosagearr"
                          label="其他"
                        ></el-checkbox
                        >:(以上都没有，请详细填写)</el-col
                      >
                      <el-input
                        v-model="scjx"
                        v-if="
                          shelfGoodsRuleForm.used_dosagearr.includes('其他')
                        "
                        placeholder="以上都没有，请详细填写"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-form-item label="是否进口：" prop="is_import">
                      <el-radio-group v-model="shelfGoodsRuleForm.is_import">
                        <el-radio
                          v-for="(item, index) in dictData.is_import"
                          :key="index"
                          :label="item"
                          >{{ item }}</el-radio
                        >
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="目前主要合作客户：" prop="partnership">
                      <el-input
                        v-model="shelfGoodsRuleForm.partnership"
                        placeholder="请输入目前主要合作客户"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!--<el-row>-->
                <!--<el-col :span="16">-->
                <!--<el-form-item label="" prop="solutionarr">-->
                <!--<span style="color: red;">* </span>解决方案： <span style="color: red;">可多选（最多限选3项）</span>-->
                <!--<div v-for="(items,index) in dictData.solution" :key="index">-->
                <!--<el-col :span="24">{{ index }}:</el-col>-->
                <!--<el-checkbox-group v-model="shelfGoodsRuleForm.solutionarr" @change="handlesolutionChange">-->
                <!--<el-checkbox    v-for="(item,idx) in items" :key="idx" :label="item"></el-checkbox>-->
                <!--</el-checkbox-group>-->
                <!--</div>-->
                <!--<el-col :span="24"><el-checkbox v-model="shelfGoodsRuleForm.solutionarr"  @change="handlesolutionChange" label="其他"></el-checkbox>:(以上都没有，请详细填写)</el-col>-->
                <!--<el-input v-model="jjfa" v-if="shelfGoodsRuleForm.solutionarr.includes('其他')"  placeholder="以上都没有，请详细填写"></el-input>-->
                <!--</el-form-item>-->
                <!--</el-col>-->
                <!--</el-row>-->
                <el-row>
                  <el-col :span="16">
                    <el-form-item label="" prop="solutionarr">
                      <span style="color: red">* </span>解决方案：
                      <span style="color: red">可多选（最多限选3项）</span>
                      <el-checkbox-group
                        v-model="shelfGoodsRuleForm.solutionarr"
                        @change="handlesolutionChange"
                      >
                        <el-checkbox
                          v-for="(item, index) in dictData.solution"
                          :key="index"
                          :label="item"
                        ></el-checkbox>
                      </el-checkbox-group>
                      <el-col :span="24"
                        ><el-checkbox
                          v-model="shelfGoodsRuleForm.solutionarr"
                          @change="handlesolutionChange"
                          label="其他"
                        ></el-checkbox
                        >:(以上都没有，请详细填写)</el-col
                      >
                      <el-input
                        v-model="jjfa"
                        v-if="shelfGoodsRuleForm.solutionarr.includes('其他')"
                        placeholder="以上都没有，请详细填写"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="16">
                    <el-form-item
                      label="可提供制造加工的剂型和产品形态："
                      prop="provide_used_dosagearr"
                    >
                      <el-checkbox-group
                        v-model="shelfGoodsRuleForm.provide_used_dosagearr"
                      >
                        <el-checkbox
                          v-for="(item, index) in dictData.provide_used_dosage"
                          :key="index"
                          :label="item"
                        ></el-checkbox>
                      </el-checkbox-group>
                      <el-col :span="24"
                        ><el-checkbox
                          v-model="shelfGoodsRuleForm.provide_used_dosagearr"
                          label="其他"
                        ></el-checkbox
                        >:(以上都没有，请详细填写)</el-col
                      >
                      <el-input
                        v-model="cpxt"
                        v-if="
                          shelfGoodsRuleForm.provide_used_dosagearr.includes(
                            '其他'
                          )
                        "
                        placeholder="以上都没有，请详细填写"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item
                      label="产品或解决方案图片"
                      prop="solution_images"
                      class="form-width"
                    >
                      <div style="display: flex">
                        <div
                          class="image-wrap"
                          v-if="shelfGoodsRuleForm.solution_images"
                        >
                          <div
                            class="image"
                            v-for="(
                              item, index
                            ) in shelfGoodsRuleForm.solution_images"
                            :key="item.url"
                          >
                            <el-image :src="$imgOssUrl + item.url"></el-image>
                            <div class="upload-span">
                              <span
                                class="upload-icon"
                                @click.stop="
                                  handlePictureCardPreview(
                                    $imgOssUrl + item.url
                                  )
                                "
                                ><i class="el-icon-zoom-in"></i
                              ></span>
                              <span
                                class="upload-icon"
                                @click.stop="handleImgRemove(index)"
                                style="margin-left: 20px"
                                ><i class="el-icon-delete"></i
                              ></span>
                            </div>
                          </div>
                        </div>

                        <div
                          v-if="shelfGoodsRuleForm.solution_images.length < 3"
                        >
                          <el-upload
                            :action="$Url"
                            list-type="picture-card"
                            :headers="headers"
                            :multiple="false"
                            :on-progress="handleProgressImgs"
                            :on-success="handleImgsSuccess"
                            :on-error="handleImgsError"
                            :show-file-list="false"
                          >
                            <i class="el-icon-plus" v-if="!progressImgsVisible"></i>
                            <div v-if="progressImgsVisible" style="padding-top: 30px">
                              <el-progress
                                      :percentage="progressImgsPercent"
                                      type="circle"
                                      :width="80"
                              ></el-progress>
                            </div>
                          </el-upload>
                        </div>
                      </div>
                    </el-form-item>
                    <!-- <el-form-item label="产品图片：" prop="imgs">
                                            <el-upload
                                              class="tp_update"
                                              action="/kindeditor/php/uploadApi.php?mode=3"
                                              name='imgFile'
                                              :on-success="handleAvatarPictureSuccess"
                                              list-type="picture-card"
                                              :show-file-list="false"

                                          >
                                              <img v-if="cpImgList[0]" :src="Imghttp + cpImgList[0]" class="avatar">
                                              <div class="upload-tip" v-else>
                                                  <i class="el-icon-plus">
                                                      <p class="el-icon-tip">请上传高清图片</p>
                                                  </i>
                                              </div>
                                          </el-upload>
                                  </el-form-item> -->
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="16">
                    <el-form-item
                      label="希望开发的客户类型："
                      prop="hope_customerarr"
                    >
                      <el-checkbox-group
                        v-model="shelfGoodsRuleForm.hope_customerarr"
                      >
                        <el-checkbox
                          v-for="(item, index) in dictData.hope_customer"
                          :key="index"
                          :label="item"
                        ></el-checkbox>
                      </el-checkbox-group>
                      <el-col :span="24"
                        ><el-checkbox
                          v-model="shelfGoodsRuleForm.hope_customerarr"
                          label="其他"
                        ></el-checkbox
                        >:(以上都没有，请详细填写)</el-col
                      >
                      <el-input
                        v-model="khlx"
                        v-if="
                          shelfGoodsRuleForm.hope_customerarr.includes('其他')
                        "
                        placeholder="以上都没有，请详细填写"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="16">
                    <el-form-item label="是否自有工厂：" prop="is_factory">
                      <el-radio-group v-model="shelfGoodsRuleForm.is_factory">
                        <el-radio
                          v-for="(item, index) in dictData.is_factory"
                          :key="index"
                          :label="item"
                          >{{ item }}</el-radio
                        >
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-form-item
                      label="是否有海外工厂："
                      prop="is_overseas_factory"
                    >
                      <el-radio-group
                        v-model="shelfGoodsRuleForm.is_overseas_factory"
                      >
                        <el-radio
                          v-for="(item, index) in dictData.is_overseas_factory"
                          :key="index"
                          :label="item"
                          >{{ item }}</el-radio
                        >
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="16">
                    <el-form-item label="是否自有原料：" prop="goodsName">
                      <el-radio-group
                        v-model="shelfGoodsRuleForm.is_self_materials"
                      >
                        <el-radio
                          v-for="(item, index) in dictData.is_self_materials"
                          :key="index"
                          :label="item"
                          >{{ item }}</el-radio
                        >
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-form-item
                      label="是否能根据客户需求提供解决方案："
                      prop="provide_solution"
                    >
                      <el-radio-group
                        v-model="shelfGoodsRuleForm.provide_solution"
                      >
                        <el-radio
                          v-for="(item, index) in dictData.provide_solution"
                          :key="index"
                          :label="item"
                          >{{ item }}</el-radio
                        >
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="16">
                    <el-form-item
                      label="是否有30天推出新品的能力："
                      prop="push_new_product"
                    >
                      <el-radio-group
                        v-model="shelfGoodsRuleForm.push_new_product"
                      >
                        <el-radio
                          v-for="(item, index) in dictData.push_new_product"
                          :key="index"
                          :label="item"
                          >{{ item }}</el-radio
                        >
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
              <!-- 选品对接会报名 表单 -->
              <template v-if="templateTpye == 2">
                <el-row>
                  <el-col :span="24">
                    <el-form-item
                      label="请选择您希望参加的对接会场次"
                      prop="match_making"
                    >
                      <el-checkbox-group
                        v-model="shelfGoodsRuleForm.match_making"
                      >
                        <el-checkbox
                          v-for="(item, index) in dictData.match_making"
                          :key="index"
                          :label="item"
                        ></el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>

              <el-row>
                <div class="zh_tips1">*签署承诺：（勾选确认生效）</div>
                <div class="zh_tips_checkbox">
                  <el-checkbox v-model="checked"
                    ><span
                      >本人经所属企业授权，承诺此页面提交的材料真实有效，无违反广告法相关规定，并同意主办方使用相关资料（个人联系方式除外）用于活动的宣传推广</span
                    ></el-checkbox
                  >
                </div>
                <el-form-item class="save_btn">
                  <el-button @click="step_up_btn(titleshow)">上一步</el-button>
                  <el-button
                    type="primary"
                    @click="submitForm('shelfGoodsRuleForm', 1)"
                    :disabled="disableds"
                    >仅保存</el-button
                  >
                  <el-button
                    type="primary"
                    @click="submitForm('shelfGoodsRuleForm', 2)"
                    :disabled="disableds"
                    >提交报名信息</el-button
                  >
                </el-form-item>
                <div
                  v-if="itemdata.id == 1"
                  class="susscess_tips"
                  style="width: 100%"
                >
                  <div>
                    注意：报名后请邮寄样品10份用于现场展示（请发空包装产品，实物产品主办方将统一处理，不再寄回）。快递外包装请注明“NHNE未来营养超市+公司名称+产品名称”
                  </div>
                  <div>
                    邮寄地址（2024年11月1日前发出快递）：北京市朝阳区新源南路1-3号平安国际金融中心B座15层，魏琳青，18810390013
                  </div>
                </div>
                <div
                  v-if="itemdata.id == 3"
                  class="susscess_tips"
                  style="width: 100%"
                >
                  <div>
                    注意：报名后请将工厂或解决方案视频短片，16:9高清格式，发送至邮箱用于：736561251@qq.com
                  </div>
                  <div>
                    邮件标题格式为：NHNE未来营养超市+公司名称+解决方案名称；邮件接收截止时间2024年11月15日
                  </div>
                </div>
              </el-row>
            </el-form>
          </template>

          <!--提交成功-->

          <el-form v-if="titleshow == 4">
            <div class="susscess_icon_box">
              <img
                class="discussion_susscess"
                mode="widthFix"
                src="../../assets/discussion/discussion_susscess.jpg"
              />
              <span>提交成功！</span>
              <div class="susscess_tips" v-if="itemdata.id == 1">
                <div>
                  注意：报名后请邮寄样品10份用于现场展示（请发空包装产品，实物产品主办方将统一处理，不再寄回）
                </div>
                <div>快递外包装请注明“NHNE未来营养超市+公司名称+产品名称”</div>
              </div>
              <div v-if="itemdata.id == 3" class="susscess_tips">
                <div>
                  注意：报名后请将工厂或解决方案视频短片，16:9高清格式，发送至邮箱用于：736561251@qq.com
                </div>
                <div>
                  邮件标题格式为：NHNE未来营养超市+公司名称+解决方案名称；邮件接收截止时间2024年11月15日
                </div>
              </div>
              <div class="adress_box" v-if="itemdata.id == 1">
                <div>邮寄地址：</div>
                <el-input
                  readonly
                  v-model="address"
                  class="adress_input"
                  ref="inputElement"
                ></el-input>
                <div class="fz_btn" @click="copyToClipboard">复制</div>
              </div>
              <div class="adress_box" v-if="itemdata.id == 3">
                <div>邮寄地址：</div>
                <el-input
                  readonly
                  v-model="address1"
                  class="adress_input"
                  ref="inputElement"
                ></el-input>
                <div class="fz_btn" @click="copyToClipboard1">复制</div>
              </div>
            </div>
            <el-form-item class="save_btn">
              <el-button type="primary" @click="goback">返回首页</el-button>
            </el-form-item>
          </el-form>

          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  marketNhneDict,
  nhneCompanydetail,
  editnhneCompany,
  nhneMarketProductdetail,
  editnhneMarketProduct,
  getEnrollProductDetail,
} from "@/api/api";
import "../../style/base.css";
import top from "../../components/top.vue"; //头部
import navMenu from "../../components/navMenu.vue"; //左侧步骤条
import qs from "qs";
export default {
  name: "productawardForm",
  components: { top, navMenu },
  data() {
    return {
      maxSelections: 3, // 允许最多选择的数量
      radio1: "",
      checkList: [],
      templateTpye: "", // 1产品基本模版表单 2 货架好物模版表单  3 选品对接会报名模版表单
      disableds: false,
      cpList: [], //
      cpImgList: [],
      zjList: [],
      fmList: [],
      lsList: [],
      isCompanyEdit: true,
      isProductEdit: true,
      dialogImageUrl: "", // 预览图片
      dialogVisible: false, //预览弹框
      tablist: {},
      titltshowlist: [1],
      titleshow: 1,
      checked: false,
      address:
        "北京市朝阳区新源南路1-3号平安国际金融中心B座15层，魏琳青，18810390013",
      address1:
        "北京市朝阳区新源南路1-3号平安国际金融中心B座15层，魏琳青，18810390013，736561251@qq.com",
      Imghttp: "https://oss.larspring.com/pharmchina",
      award_id: "", //奖项id
      product_id: "", //产品id
      companyForm: {
        companyName: "", //公司名称
        boothNo: "", //展位号
        exhibitionArea: "", //展区
        hallNo: "", //展馆号
        contacts: "", //联系人
        telephoneNumber: "", //手机号
        email: "", //邮箱
        address: "", //联系地址
        introduction: "", //公司介绍
        logo: "",
      },
      companyFormRules: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        contacts: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        telephoneNumber: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入联系地址", trigger: "blur" },
        ],
        introduction: [
          { required: true, message: "请输入公司介绍", trigger: "blur" },
        ],
      },
      productForm: {
        goodsName: "", //产品名称
        yearSale: "", //年销售额
        nhne_ProductClass: "", //产品类别
        features: "", //产品特点
        newfeatures: [],
        cpintroduction: "",
        introduction: "", //产品简介
        burdenImg: [], //产品配料表
        characteristic: "", //工艺特点
        advantages: "", //产品卖点
        imgs: [], //产品图片
      },
      productFormRules: {
        goodsName: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
        ],
        yearSale: [
          { required: true, message: "请输入年销售额", trigger: "blur" },
        ],
        nhne_ProductClass: [
          { required: true, message: "请输入产品类别", trigger: "blur" },
        ],
        newfeatures: [
          {
            required: true,
            message: "请选择至少一个产品特点",
            trigger: "blur",
          },
        ],
        cpintroduction: [
          { required: true, message: "请输入产品简介", trigger: "blur" },
        ],
        advantages: [
          { required: true, message: "请输入产品卖点", trigger: "blur" },
        ],
        characteristic: [
          { required: true, message: "请输入工艺特点", trigger: "blur" },
        ],
        burdenImg: [
          { required: true, message: "请上传产品配料表", trigger: "blur" },
        ],
        imgs: [{ required: true, message: "请上传产品图片", trigger: "blur" }],
      },
      reportForm: {
        inspectionReport: [], //质检报告
        productPatent: [], //生产专利
        historyAward: [], //历史获奖
      },
      timeOperation: {}, //奖项开始时间-结束时间
      productlist: [],

      shelfGoodsRuleForm: {
        changeproductClass: [],
        goodsName: "", //产品图片
        productClass: "", //产品类别
        imgs: "",
        sales_channel: "",
        retail_price: "",
        up_suggest1: "",
        up_suggest: "",
        producible_dosage: "",
        expand_channels: "",
        market_time_new: "",
        market_time: "",
        solutionarr: [],
        solution: "",
        used_dosagearr: [],
        used_dosage: "",
        solution_images: [],
        solution_image: "",
        partnership: "",
        hope_customer: "",
        hope_customerarr: [],
        is_factory: "",
        is_overseas_factory: "",
        is_self_materials: "",
        provide_solution: "",
        push_new_product: "",
        yearSale: "",
        provide_used_dosage: "",
        provide_used_dosagearr: [],
        introduction: "",
        is_import: "",
        match_making: [],
      },
      shelfGoodsRules: {
        goodsName: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
        ],
        changeproductClass: [
          { required: true, message: "请输入产品类别", trigger: "change" },
        ],
        market_time_new: [
          {
            type: "date",
            required: true,
            message: "请选择上市时间",
            trigger: "change",
          },
        ],
        yearSale: [
          { required: true, message: "请输入产品年销售额", trigger: "blur" },
        ],
        retail_price: [
          { required: true, message: "请输入产品零售价", trigger: "blur" },
        ],
        sales_channel: [
          {
            required: true,
            message: "请输入目前已有主要销售渠道",
            trigger: "blur",
          },
        ],
        expand_channels: [
          {
            required: true,
            message: "请输入希望开拓销售渠道",
            trigger: "blur",
          },
        ],
        introduction: [
          { required: true, message: "请输入产品简介", trigger: "blur" },
        ],
        imgs: [{ required: true, message: "请上传产品图片", trigger: "blur" }],
        up_suggest1: [
          { required: true, message: "请选择货架选择", trigger: "change" },
        ],
        used_dosagearr: [
          {
            type: "array",
            required: true,
            message: "请选择可生产剂型",
            trigger: "change",
          },
        ],
        is_import: [
          { required: true, message: "请选择是否进口", trigger: "change" },
        ],
        partnership: [
          { required: true, message: "请选择是否进口", trigger: "blur" },
        ],
        solutionarr: [
          {
            type: "array",
            required: true,
            message: "请选择解决方案",
            trigger: "change",
          },
        ],
        provide_used_dosagearr: [
          {
            type: "array",
            required: true,
            message: "请选择可提供制造加工的剂型和产品形态",
            trigger: "change",
          },
        ],
        solution_images: [
          {
            type: "array",
            required: true,
            message: "请上传产品或解决方案图片",
            trigger: "change",
          },
        ],
        hope_customerarr: [
          {
            type: "array",
            required: true,
            message: "请选择希望开发的客户类型",
            trigger: "change",
          },
        ],
        is_factory: [
          { required: true, message: "请选择是否自有工厂", trigger: "blur" },
        ],
        is_overseas_factory: [
          { required: true, message: "请选择是否有海外工厂", trigger: "blur" },
        ],
        is_self_materials: [
          { required: true, message: "请选择是否自有原料", trigger: "blur" },
        ],
        provide_solution: [
          {
            required: true,
            message: "请选择是否能根据客户需求提供解决方案",
            trigger: "blur",
          },
        ],
        push_new_product: [
          {
            required: true,
            message: "请选择是否有30天推出新品的能力",
            trigger: "blur",
          },
        ],
        match_making: [
          {
            type: "array",
            required: true,
            message: "请选择您希望参加的对接会场次",
            trigger: "change",
          },
        ],
      },
      dictData: {},
      headers: {},
      id: "",
      maxselectionSelections: 1,
      maxsolutionSelections: 3,
      itemdata: {},
      productClass: [],
      hjxz: "",
      scjx: "",
      jjfa: "",
      cpxt: "",
      khlx: "",
        progressCpVisible: false,
        progressCpPercent: 0,
        progressImgsVisible:false,
        progressImgsPercent:0,
        progressLogoVisible:false,
        progressLogoPercent:0,
      pickeroptions0: {
        disabledDate(date) {
          if (!date) return false; // 如果日期为空，允许选择
          const today = new Date();
          today.setHours(0, 0, 0, 0); // 设置为当天的00:00:00
          const tomorrow = new Date(today);
          tomorrow.setDate(today.getDate() + 1); // 计算明天的日期
          return date.getTime() >= tomorrow.getTime(); // 禁用明天及之后的日期
        },
      },
    };
  },
  created() {
    this.itemdata = JSON.parse(sessionStorage.getItem("itemdata"));
    this.dictData = JSON.parse(sessionStorage.getItem("dictData"));
    this.productClass = JSON.parse(sessionStorage.getItem("productClass"));
  },
  mounted() {
    //获取url上的参数
    // this.award_id = this.getQueryString('id');
    // this.product_id=this.getQueryString('product_id')

    // 获取企业详情
    // this.getDetails();
    // this.gettablist();
    // this.productDetail();
    // this.getproductlist();

    // if(!productForm.goodsName){
    //     this.isProductEdit=false
    // }else{
    //     this.isProductEdit=true
    // }

    let token = localStorage.getItem("token");
    this.headers = {
      token: token,
    };
    this.id = this.$route.query.id;
    this.templateTpye = this.itemdata.id;
    // this.getmarketNhneDict()
    this.getnhneMarketProductdetail();
    this.getnhneCompanydetail();
    this.getEnrollProductDetail();
  },
  methods: {
      handleProgressImgs(event, file, fileList) {
          console.log(event, "====event");
          // 显示进度条
          this.progressImgsVisible = true;
          // 计算进度百分比
          this.progressImgsPercent = Math.floor((event.loaded / event.total) * 100);
      },
      handleProgressCp(event, file, fileList) {
          console.log(event, "====event");
          // 显示进度条
          this.progressCpVisible = true;
          // 计算进度百分比
          this.progressCpPercent = Math.floor((event.loaded / event.total) * 100);
      },
      handleProgresslogo(event, file, fileList) {
          console.log(event, "====event");
          // 显示进度条
          this.progressLogoVisible = true;
          // 计算进度百分比
          this.progressLogoPercent = Math.floor((event.loaded / event.total) * 100);
      },

    // 评奖详情
    async getEnrollProductDetail() {
      let data = { id: this.id, awards_id: this.itemdata.id };
      const res = await getEnrollProductDetail(this.$qs.stringify(data));

      if (res.data.code === 1) {
        console.log(res, "res====");

        const productData = res.data.data;

        if (this.itemdata.id == 2) {
          this.shelfGoodsRuleForm.match_making =
            productData.match_making.split(",");
        }
        this.$forceUpdate();
      }
    },
    goback() {
      this.$router.back();
    },
    processArray(arr, additionalOptions) {
      // 初始化结果数组
      const resultArray = [];

      // 初始化提取的选项数组
      const extractedOptions = [];

      // 遍历原始数组
      arr.forEach((item) => {
        // 判断字符串中是否包含 #
        const hashIndex = item.indexOf("#");

        if (hashIndex !== -1) {
          // 如果包含 #，提取 # 后的部分
          const extractedItem = item.slice(hashIndex + 1);
          extractedOptions.push(extractedItem);
        } else {
          // 不包含 # 的项添加到结果数组中
          resultArray.push(item);
        }
      });

      // 将其他选项添加到结果数组
      resultArray.push(...additionalOptions);

      return {
        resultArray,
        extractedOptions,
      };
    },
    // 获取产品详情
    async getnhneMarketProductdetail() {
      const additionalOptions = ["其他"];
      try {
        const data = { id: this.id };
        const res = await nhneMarketProductdetail(data);

        if (res.data.code === 1) {
          console.log(res, "res====");

          const productData = res.data.data;
          this.shelfGoodsRuleForm.goodsName = productData.goodsName;

          const productClass = this.dictData.productClass || [];

          // 初始化结果数组
          let changeproductClass = [];

          // 遍历 productClass 对象的键
          for (const key in productClass) {
            if (
              productClass.hasOwnProperty(key) &&
              productClass[key].includes(productData.productClass)
            ) {
              changeproductClass.push(key, productData.productClass);
            }
          }

          // 更新 changeproductClass 的值
          this.shelfGoodsRuleForm.changeproductClass = changeproductClass;
          this.shelfGoodsRuleForm.productClass = changeproductClass[1];

          console.log(productData.market_time, "productData.market_time");

          let marketTimeInSeconds = "";
          if (
            productData.market_time == "" ||
            productData.market_time == null
          ) {
            const date = Math.floor(Date.now() / 1000);
            marketTimeInSeconds = date * 1000;
            // 创建日期对象
            marketTimeInSeconds = new Date(marketTimeInSeconds);
          } else {
            marketTimeInSeconds = parseInt(
              new Date(productData.market_time).getTime()
            );
          }

          Object.assign(this.shelfGoodsRuleForm, {
            productClass: productData.productClass,
            market_time_new: marketTimeInSeconds,
            market_time: productData.market_time,
            yearSale: productData.yearSale,
            retail_price: productData.retail_price,
            sales_channel: productData.sales_channel,
            expand_channels: productData.expand_channels,
            introduction: productData.introduction,
            used_dosage: productData.used_dosage,
            used_dosagearr: productData.used_dosage.split(","),
            up_suggest: productData.up_suggest,
            up_suggest1: productData.up_suggest,
            is_import: productData.is_import,
            imgs: productData.imgs,
          });
          let new_up_suggest = [];
          for (const key in this.dictData.up_suggest) {
            this.dictData.up_suggest.map((item) => {
              new_up_suggest.push(item);
            });
          }
          // console.log(this.shelfGoodsRuleForm.up_suggestarr,"this.shelfGoodsRuleForm.up_suggestarr")
          // this.shelfGoodsRuleForm.up_suggestarr = this.shelfGoodsRuleForm.up_suggestarr.filter(item =>  new Set(new_up_suggest).has(item) || this.startsWithHash(item) || item === '其他');

          // 可生产剂型
          this.shelfGoodsRuleForm.used_dosagearr =
            this.shelfGoodsRuleForm.used_dosagearr.filter(
              (item) =>
                new Set(this.dictData.used_dosage).has(item) ||
                this.startsWithHash(item) ||
                item === "其他"
            );

          // // 判断数组中是否包含以 # 开头的元素
          // const hasup_sugge = this.shelfGoodsRuleForm.up_suggestarr.some(item => item.startsWith('#'));
          // if(hasup_sugge){
          //     let up_suggest_new=this.processArray(this.shelfGoodsRuleForm.up_suggestarr, additionalOptions);
          //     this.shelfGoodsRuleForm.up_suggestarr=up_suggest_new.resultArray
          //
          //     this.hjxz=up_suggest_new.extractedOptions[0]
          // }
          // 判断数组中是否包含包含 # 的元素
          const hasHash = this.shelfGoodsRuleForm.up_suggest.includes("#");

          if (hasHash) {
            this.hjxz = this.shelfGoodsRuleForm.up_suggest1.replace(/#/g, "");
            this.shelfGoodsRuleForm.up_suggest1 = "其他";
            console.log(this.hjxz, " this.hjxz");
          }

          const hasused_dosage = this.shelfGoodsRuleForm.used_dosagearr.some(
            (item) => item.startsWith("#")
          );
          if (hasused_dosage) {
            let used_dosage_new = this.processArray(
              this.shelfGoodsRuleForm.used_dosagearr,
              additionalOptions
            );
            this.shelfGoodsRuleForm.used_dosagearr =
              used_dosage_new.resultArray;
            this.scjx = used_dosage_new.extractedOptions[0];
          }

          if (productData.productClass === "OEM") {
            const solutionImages = productData.solution_image
              .split(",")
              .map((item) => ({ url: item }));

            Object.assign(this.shelfGoodsRuleForm, {
              partnership: productData.partnership,
              solution: productData.solution,
              solutionarr: productData.solution.split(","),
              hope_customer: productData.hope_customer,
              hope_customerarr: productData.hope_customer.split(","),
              provide_used_dosage: productData.provide_used_dosage,
              provide_used_dosagearr:
                productData.provide_used_dosage.split(","),
              solution_images: solutionImages,
              is_factory: productData.is_factory,
              is_overseas_factory: productData.is_overseas_factory,
              is_self_materials: productData.is_self_materials,
              provide_solution: productData.provide_solution,
              push_new_product: productData.push_new_product,
            });
            let new_solution = [];
            for (const key in this.dictData.solution) {
              this.dictData.solution[key].map((item) => {
                new_solution.push(item);
              });
            }
            this.shelfGoodsRuleForm.solutionarr =
              this.shelfGoodsRuleForm.solutionarr.filter(
                (item) =>
                  new Set(new_solution).has(item) ||
                  this.startsWithHash(item) ||
                  item === "其他"
              );

            this.shelfGoodsRuleForm.hope_customerarr =
              this.shelfGoodsRuleForm.hope_customerarr.filter(
                (item) =>
                  new Set(this.dictData.hope_customer).has(item) ||
                  this.startsWithHash(item) ||
                  item === "其他"
              );
            this.shelfGoodsRuleForm.provide_used_dosagearr =
              this.shelfGoodsRuleForm.provide_used_dosagearr.filter(
                (item) =>
                  new Set(this.dictData.provide_used_dosage).has(item) ||
                  this.startsWithHash(item) ||
                  item === "其他"
              );

            // 判断数组中是否包含以 # 开头的元素
            const hassolutionarr = this.shelfGoodsRuleForm.solutionarr.some(
              (item) => item.startsWith("#")
            );
            if (hassolutionarr) {
              let solution_new = this.processArray(
                this.shelfGoodsRuleForm.solutionarr,
                additionalOptions
              );
              this.shelfGoodsRuleForm.solutionarr = solution_new.resultArray;
              this.jjfa = solution_new.extractedOptions[0];
            }
            const hashope_customer =
              this.shelfGoodsRuleForm.hope_customerarr.some((item) =>
                item.startsWith("#")
              );
            if (hashope_customer) {
              let hope_customer_new = this.processArray(
                this.shelfGoodsRuleForm.hope_customerarr,
                additionalOptions
              );
              this.shelfGoodsRuleForm.hope_customerarr =
                hope_customer_new.resultArray;
              this.khlx = hope_customer_new.extractedOptions[0];
            }
            const hasprovide_used_dosage =
              this.shelfGoodsRuleForm.provide_used_dosagearr.some((item) =>
                item.startsWith("#")
              );
            if (hasprovide_used_dosage) {
              let provide_used_dosage_new = this.processArray(
                this.shelfGoodsRuleForm.provide_used_dosagearr,
                additionalOptions
              );
              this.shelfGoodsRuleForm.provide_used_dosagearr =
                provide_used_dosage_new.resultArray;
              this.cpxt = provide_used_dosage_new.extractedOptions[0];
            }
          }
        }
      } catch (err) {
        console.error("Error fetching product details:", err);
      }
    },
    startsWithHash(str) {
      return str.startsWith("#");
    },
    // 货架选择 只能选择一项
    handleselectionChange(value) {
      // 如果选择的项数超过最大限制
      if (
        this.shelfGoodsRuleForm.up_suggestarr.length >
        this.maxselectionSelections
      ) {
        // 取出超出的项
        this.$message.error(`最多只能选择 ${this.maxselectionSelections} 项`);

        // 使选项回到上一个合法状态
        this.shelfGoodsRuleForm.up_suggestarr =
          this.shelfGoodsRuleForm.up_suggestarr.slice(
            0,
            this.maxselectionSelections
          );
      }
    },
    // 解决方案 只能选择三项
    handlesolutionChange() {
      // 如果选择的项数超过最大限制
      if (
        this.shelfGoodsRuleForm.solutionarr.length > this.maxsolutionSelections
      ) {
        // 取出超出的项
        this.$message.error(`最多只能选择 ${this.maxsolutionSelections} 项`);

        // 使选项回到上一个合法状态
        this.shelfGoodsRuleForm.solutionarr =
          this.shelfGoodsRuleForm.solutionarr.slice(
            0,
            this.maxsolutionSelections
          );
      }
    },
    handleChange(value) {
      this.shelfGoodsRuleForm.productClass = value[1];
    },
    //   // 获取评奖表单字典数据
    //   getmarketNhneDict(){
    //         marketNhneDict({}).then(res=>{
    //             if(res.data.code==1){
    //                this.dictData=res.data.data;
    //                 // 直接从响应中提取数据
    //                 const { productClass } = res.data.data;
    //                 if (productClass) {
    //                     // 处理 productClass 的转换
    //                     this.productClass = Object.entries(productClass).map(([key, items]) => ({
    //                     label: key,
    //                     value: key,
    //                     children: items.map(item => ({
    //                         label: item,
    //                         value: item
    //                     }))
    //                     }));
    //                 }

    //             }
    //         }).catch(err=>{
    //             console.log(err)
    //         })
    //     },

    // 产品图片删除
    handlecpRemove(file, fileList) {
      this.shelfGoodsRuleForm.imgs = "";
    },
    handlecpSuccess(resData, file, fileList) {
      if (resData.code == 0) {
        this.$message.error(resData.msg);
        return false;
      }
      this.shelfGoodsRuleForm.imgs = resData.data.url;
        this.progressCpVisible = false;
    },
    // 产品图片上传失败
    handlecpError(err, file, fileList) {
      this.$message.error(err.msg);
        this.progressCpVisible = false;
    },
    //产品或解决方案图片上传成功
    handleImgsSuccess(resData, file, fileList) {
      if (resData.code == 0) {
        this.$message.error(resData.msg);
        return false;
      }
      this.shelfGoodsRuleForm.solution_images.push({ url: resData.data.url });
        this.progressImgsVisible=false
    },
    // 产品或解决方案图片上传失败
    handleImgsError(err, file, fileList) {
      this.$message.error(err.message);
        this.progressImgsVisible=false
    },
    //产品或解决方案图片删除
    handleImgRemove(index) {
      this.shelfGoodsRuleForm.solution_images.splice(index, 1);
    },
    //预览图片
    handlePictureCardPreview(file) {
      console.log(file, "file");
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },

    //  仅保存 && 添加产品
    submitForm(formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.checked) {
            this.$message.warning("请勾选签署承诺");
            return false;
          }
          this.disableds = true;
          setTimeout(() => {
            this.disableds = false;
          }, 2000);

          const data = this.shelfGoodsRuleForm;

          console.log(data, "data");

          data.up_suggest = data.up_suggest1;

          if (data.up_suggest == "其他") {
            // data.up_suggestarr = data.up_suggestarr.filter(item => item !== '其他');
            data.up_suggest = "#" + this.hjxz;
          }
          if (data.used_dosagearr.includes("其他")) {
            data.used_dosagearr = data.used_dosagearr.filter(
              (item) => item !== "其他"
            );
            data.used_dosagearr.push("#" + this.scjx);
          }
          data.used_dosage = data.used_dosagearr.join(",");

          data.market_time = moment(data.market_time_new).format("YYYY-MM-DD");

          if (this.itemdata.id == 3) {
            data.productClass = "OEM";
            if (data.solutionarr.includes("其他")) {
              data.solutionarr = data.solutionarr.filter(
                (item) => item !== "其他"
              );
              data.solutionarr.push("#" + this.jjfa);
            }
            if (data.hope_customerarr.includes("其他")) {
              data.hope_customerarr = data.hope_customerarr.filter(
                (item) => item !== "其他"
              );
              data.hope_customerarr.push("#" + this.khlx);
            }
            if (data.provide_used_dosagearr.includes("其他")) {
              data.provide_used_dosagearr = data.provide_used_dosagearr.filter(
                (item) => item !== "其他"
              );
              data.provide_used_dosagearr.push("#" + this.cpxt);
            }
            data.solution = data.solutionarr.join(",");
            data.hope_customer = data.hope_customerarr.join(",");
            data.provide_used_dosage = data.provide_used_dosagearr.join(",");
            data.solution_image = data.solution_images
              .map((item) => item.url)
              .join(",");
          }
          data.id = this.id;

          if (this.itemdata.id == 2) {
            data.match_making = data.match_making.join(",");
          }

          if (type === 1) {
            data.operation_type = 1;
          } else {
            //货架好物报名
            if (this.itemdata.id == 1) {
              let marketTimeStatus = this.isProductAvailableAfterDate(
                new Date(data.market_time)
              );
              // if (!marketTimeStatus) {
              //   this.$message.warning(
              //     "参选产品仅支持2022年1月1日（包含）之后的产品"
              //   );
              //   return;
              // }
                if (!marketTimeStatus) {
                  this.$message.warning(
                    "参选产品仅支持2022年1月1日（包含）之后的产品"
                  );
                 
                }
            }
            // 提交报名信息
            data.operation_type = 2;
            data.awards_id = this.itemdata.id;
            data.awards_name = this.itemdata.name;

          }
          editnhneMarketProduct(this.$qs.stringify(data))
            .then((res) => {
              const msg = res.data.msg;
              if (res.data.code === 1) {
                this.$message.success(msg);
                if (type == 2) {
                  this.titleshow = 4;
                } else {
                  this.goback();
                }
              } else {
                this.$message.warning(msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    isProductAvailableAfterDate(date) {
      const comparisonDate = new Date("2022-01-01T00:00:00Z"); // 设定的日期
      return date >= comparisonDate; // 如果日期在2023年1月1日或之后，返回true
    },
    // 获取评奖表单企业详情
    getnhneCompanydetail() {
      nhneCompanydetail({})
        .then((res) => {
          console.log(res, "res");
          if (res.data.code == 1) {
            this.companyForm = res.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //  公司信息点击下一步
    step_btn_new(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let {
            companyName,
            contacts,
            telephoneNumber,
            email,
            address,
            introduction,
            logo,
            hallNo,
            boothNo,
            exhibitionArea,
          } = this.companyForm;
          let data = {
            companyName,
            contacts,
            telephoneNumber,
            email,
            address,
            introduction,
            logo,
            hallNo,
            boothNo,
            exhibitionArea,
          };
          console.log(data, "=====data");
          this.editDetailnew(qs.stringify(data));
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //修改企业信息
    editDetailnew(data) {
      editnhneCompany(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.titleshow = 2;
            this.titltshowlist.push(2);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    handleRemove(file, fileList) {
      this.companyForm.logo = "";
    },
    // logo上传成功
    handleLogoSuccess(resData, file, fileList) {
      if (resData.code == 0) {
        this.$message.error(resData.msg);
        return false;
      }
      this.companyForm.logo = resData.data.url;
        this.progressLogoVisible = false;
    },
    // logo上传失败
    handleLogoError(err, file, fileList) {
      this.$message.error(err.message);
        this.progressLogoVisible = false;
    },

    // 基本表单逻辑 24.8.17
    //编辑企业信息状态
    editCompany() {
      this.isCompanyEdit = !this.isCompanyEdit;
    },
    //编辑产品信息状态
    editProduct() {
      this.isProductEdit = !this.isProductEdit;
    },
    // goback(){
    //      window.location.href=`<?= URL('discussion.productawardList','id='); ?>${this.award_id}`
    // },
    getproductlist() {
      // axios.get('api.php?m=nhneProduct.getProductClass&v=3.0',{}).then(res => {
      //         //console.log(res, '---获取奖项列表');
      //         if(res.status == 200){
      //             let data = res.data.rst;
      //             this.productlist = data;
      //         }
      //     }).catch(function (err) {
      //         console.log(err);
      //     });
    },
    gettablist() {
      axios
        .get("api.php?m=nhneProduct.getProductOption&v=3.0", {})
        .then((res) => {
          //console.log(res, '---获取奖项列表');
          if (res.status == 200) {
            let data = res.data.rst;
            this.tablist = data;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    // 获取企业信息
    getDetails() {
      axios
        .get("api.php?m=nhnecompany.getDetail&v=3.0", {})
        .then((res) => {
          //console.log(res, '---获取企业详情');
          if (res.status == 200) {
            let data = res.data.rst;
            console.log(data, "===data");
            this.companyForm.companyName = data.companyName;
            this.companyForm.boothNo = data.boothNo;
            this.companyForm.exhibitionArea = data.exhibitionArea;
            this.companyForm.hallNo = data.hallNo;
            this.companyForm.contacts = data.contacts;
            this.companyForm.telephoneNumber = data.telephoneNumber;
            this.companyForm.email = data.email;
            this.companyForm.address = data.address;
            this.companyForm.introduction = data.introduction;
          }
        })
        .catch(function (err) {
          //console.log(err);
        });
    },
    //修改企业信息
    editDetail(data) {
      axios
        .post("api.php?m=nhnecompany.editDetail&v=3.0", data)
        .then((res) => {
          console.log(res, "---修改企业信息");
          if (res.status == 200) {
            this.titleshow = 2;
            this.titltshowlist.push(2);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //  公司信息点击下一步
    step_btn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let {
            companyName,
            contacts,
            telephoneNumber,
            email,
            address,
            introduction,
          } = this.companyForm;
          let data = {
            companyName,
            contacts,
            telephoneNumber,
            email,
            address,
            introduction,
          };
          console.log(data, "=====data");
          this.editDetail(qs.stringify(data));
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 产品详情
    productDetail() {
      axios
        .post(
          "api.php?m=nhneProduct.getDetail&v=3.0",
          qs.stringify({
            id: this.product_id,
            award_id: this.award_id,
          })
        )
        .then((res) => {
          if (res.status == 200) {
            let data = res.data.rst;
            this.timeOperation = data.awards;
            console.log(data.awards, "data.awards");
            this.productForm.goodsName = data.goodsName;
            this.productForm.yearSale = data.yearSale;
            this.productForm.nhne_ProductClass = data.nhne_ProductClass;
            this.productForm.cpintroduction = data.introduction;
            this.productForm.advantages = data.advantages;
            this.productForm.characteristic = data.characteristic;
            if (data.features) {
              this.productForm.newfeatures = data.features.split(",");
            }

            if (data.burdenImg) {
              let list = [];
              this.cpList = JSON.parse(data.burdenImg);
              this.cpList.map((item) => {
                list.push({
                  url: item,
                });
              });
              this.productForm.burdenImg = list;
            }

            if (data.imgs) {
              let list = [];
              this.cpImgList = JSON.parse(data.imgs);
              this.cpImgList.map((item) => {
                list.push({
                  url: item,
                });
              });
              this.productForm.imgs = list;
            }

            if (data.inspectionReport) {
              let list = [];
              this.zjList = JSON.parse(data.inspectionReport);
              this.zjList.map((item) => {
                list.push({
                  url: item,
                });
              });
              this.reportForm.inspectionReport = list;
            }

            if (data.productPatent) {
              let list = [];
              this.fmList = JSON.parse(data.productPatent);
              this.fmList.map((item) => {
                list.push({
                  url: item,
                });
              });
              this.reportForm.productPatent = list;
            }

            if (data.historyAward) {
              let list = [];
              this.lsList = JSON.parse(data.historyAward);
              this.lsList.map((item) => {
                list.push({
                  url: item,
                });
              });
              this.reportForm.historyAward = list;
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    // // 产品信息点击下一步
    // step_product_btn(formName){
    //      this.$refs[formName].validate((valid) => {
    //          if(this.productForm.cpintroduction){
    //              this.productForm.introduction=this.productForm.cpintroduction
    //          }
    //         if (valid) {
    //           if(this.product_id){
    // 		          this.productForm.product_id=this.product_id
    // 		    }

    //            if(this.productForm.newfeatures.length>0){
    // 	            this.productForm.features=this.productForm.newfeatures+''
    // 	        }
    // 	        let data=Object.assign({},this.productForm)

    // 	         if(this.productForm.imgs.length>0){
    // 	            data.imgs=JSON.stringify(this.cpImgList)
    // 	        }

    // 	        if(this.productForm.burdenImg.length>0){
    // 	               data.burdenImg=JSON.stringify(this.cpList)

    // 	        }

    // 	    console.log(this.productForm,"this.productForm")

    //         axios.post('api.php?m=nhneProduct.updateData&v=3.0',qs.stringify(data)).then(res => {
    //             //console.log(res, '---获取详情');
    //             if(res.status == 200){
    //                 this.titleshow = 3;
    //                 this.titltshowlist.push(3)
    //             }

    //         })
    //         .catch(function (err) {
    //             console.log(err);
    //         });

    //         } else {
    //             console.log('error submit!!');
    //             return false;
    //         }
    //     });
    // },
    isJSONStringified(str) {
      return /^(\{.*\}|\[.*\])$/.test(str);
    },
    //参选产品信息上传仅保存
    saveOnly(formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.disableds = true;
          setTimeout(() => {
            this.disableds = false;
          }, 2000);
          //开始时间戳
          let startime = this.timeOperation.reg_starttime;
          //结束时间戳
          let endtime = this.timeOperation.reg_endtime;
          //当前时间戳
          let timestamp = Date.now() / 1000;
          //是否开始时间
          if (timestamp < startime) {
            this.$message.warning(
              `报名未开始,开始时间${this.timeOperation.startdate}`
            );
            return false;
          }
          //是否结束时间
          if (endtime < timestamp) {
            this.$message.warning("报名已截止");
            return false;
          }
          if (type == "1" && !this.checked) {
            this.$message.warning("请勾选签署承诺");
            return false;
          }

          if (this.product_id) {
            this.reportForm.product_id = this.product_id;
          }
          let data = Object.assign({}, this.reportForm);

          if (this.reportForm.inspectionReport.length > 0) {
            data.inspectionReport = JSON.stringify(this.zjList);
          }

          if (this.reportForm.productPatent.length > 0) {
            data.productPatent = JSON.stringify(this.fmList);
          }

          if (this.reportForm.historyAward.length > 0) {
            data.historyAward = JSON.stringify(this.lsList);
          }
          //保存并提交
          if (type == 1) {
            data.submit = 1;
            data.awardsid = this.award_id;
          }

          axios
            .post("api.php?m=nhneProduct.updateData&v=3.0", qs.stringify(data))
            .then((res) => {
              //console.log(res, '---获取详情');
              if (res.status == 200) {
                if (type == 1) {
                  this.titleshow = 4;
                } else {
                  this.$message.success("保存成功!");
                  console.log(this.award_id);
                  let that = this;

                  setTimeout(function () {
                    window.location.href = `<?= URL('discussion.productawardList'); ?>&id=${that.award_id}`;
                  }, 500);
                }
              }
            })
            .catch(function (err) {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //  点击上一步
    step_up_btn(titleshow) {
      console.log(this.titleshow, "titleshow");
      //
      if (titleshow == 3) {
        this.titleshow = 2;
        this.titltshowlist.splice(2, 1);
        this.getDetails();
      } else if (titleshow == 2) {
        this.titleshow = 1;
        this.titltshowlist.splice(1, 1);
      }
    },
    // //  仅保存 && 保存并提交
    // submitForm(ruleForm,type){
    //     // 仅保存
    //     if(type==1){

    //     }else{//保存并提交
    //          // 提交成功页等于4
    //          this.titleshow=4

    //     }

    // },
    // 复制地址
    async copyToClipboard() {
      const inputElement = this.$refs.inputElement;
      inputElement.select();
      try {
        await navigator.clipboard.writeText(this.address);
        this.$message.success("复制成功");
      } catch (error) {
        this.$message.error("复制失败，请手动复制");
      }
    },
    // 复制地址
    async copyToClipboard1() {
      const inputElement = this.$refs.inputElement;
      inputElement.select();
      try {
        await navigator.clipboard.writeText(this.address1);
        this.$message.success("复制成功");
      } catch (error) {
        this.$message.error("复制失败，请手动复制");
      }
    },
    //产品图片上传
    handleAvatarPictureSuccess(res, file, fileList) {
      let fileUrl = [];
      let newfileUrl = [];
      // 处理上传成功的响应数据
      if (res.errno == 0) {
        fileUrl.push({
          url: res.url,
        });

        newfileUrl.push(res.url);
        // 在这里可以使用获取到的文件 URL 进行后续操作
        this.productForm.imgs = fileUrl;
        this.cpImgList = newfileUrl;
      } else {
        // 处理上传失败的情况
        console.error("上传失败");
      }
    },
    // 判断是否pdf
    isPDF(url) {
      if (!url) {
        return false;
      }
      const fileType = ["pdf"];
      const index = url.lastIndexOf(".");
      const type = url.substr(index + 1);
      return fileType.indexOf(type) > -1;
    },
    //预览图片
    handlePreview(file, fileList) {
      if (this.isPDF(file.url)) {
        window.open(file.url, "_blank");
      } else {
        console.log(file.url);
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      }
    },

    //产品配料表删除
    //   handleRemove(file, fileList) {
    //        this.$confirm(`确认删除文件?`, '提示', {
    //             confirmButtonText: '确定',
    //             cancelButtonText: '取消',
    //             type: 'warning'
    //         }).then(async () => {
    //             let list=[]
    //             this.productForm.burdenImg = this.productForm.burdenImg.filter((v) => v.url !== file.url)
    //             this.productForm.burdenImg.map(item=>{
    //                    list.push(item.url)
    //             })
    //             this.cpList=list

    //         }).catch(()=>{})
    //   },
    //   zhang 4.9  //产品配料表上传
    beforeUpload(file) {
      // 检查文件类型
      if (file.type == "image/jpeg" || file.type == "application/pdf") {
        this.dir = file.type == "image/jpeg" ? "image" : "file";
        let formData = new FormData();
        formData.append("imgFile", file);

        axios
          .post("kindeditor/php/uploadApi.php?mode=3&dir=" + this.dir, formData)
          .then((res) => {
            console.log(res, "res");
            if (res.data.errno == 0) {
              let data = {
                url: res.data.url,
                uid: file.uid,
              };
              this.productForm.burdenImg = [
                ...this.productForm.burdenImg,
                data,
              ];
              this.cpList.push(data.url);
              this.$forceUpdate();
            }
          })
          .catch(function (err) {
            console.log(err);
          });

        return true;
      } else {
        this.$message.error("只能上传 JPEG JPG PNG PDF 格式的图片！");
        return false;
      }
    },

    //质检报告删除
    handlezjRemove(file, fileList) {
      this.$confirm(`确认删除文件?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let list = [];
          this.reportForm.inspectionReport =
            this.reportForm.inspectionReport.filter((v) => v.url !== file.url);
          this.reportForm.inspectionReport.map((item) => {
            list.push(item.url);
          });
          this.zjList = list;
        })
        .catch(() => {});
    },
    //质检报告上传
    beforeUploadzj(file) {
      // 检查文件类型
      if (file.type == "image/jpeg" || file.type == "application/pdf") {
        this.dir = file.type == "image/jpeg" ? "image" : "file";
        let formData = new FormData();
        formData.append("imgFile", file);

        axios
          .post("kindeditor/php/uploadApi.php?mode=3&dir=" + this.dir, formData)
          .then((res) => {
            console.log(res, "res");
            if (res.data.errno == 0) {
              let data = {
                url: res.data.url,
                uid: file.uid,
              };
              this.reportForm.inspectionReport = [
                ...this.reportForm.inspectionReport,
                data,
              ];
              this.zjList.push(data.url);
              this.$forceUpdate();
            }
          })
          .catch(function (err) {
            console.log(err);
          });

        return true;
      } else {
        this.$message.error("只能上传 JPEG JPG PNG PDF 格式的图片！");
        return false;
      }
    },
    // handlezjSuccess(response, file, fileList) {
    //   if (response.errno == 0) {
    //         let data = {
    //             url: file.response.url,
    //             uid: file.uid,
    //         }
    //         this.reportForm.inspectionReport = [...this.reportForm.inspectionReport, data];
    //          this.zjList.push(data.url)
    //         this.$forceUpdate();
    //     }
    //   },

    //生产专利删除
    handlefmscRemove(file, fileList) {
      this.$confirm(`确认删除文件?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let list = [];
          this.reportForm.productPatent = this.reportForm.productPatent.filter(
            (v) => v.url !== file.url
          );
          this.reportForm.productPatent.map((item) => {
            list.push(item.url);
          });
          this.fmList = list;
        })
        .catch(() => {});
    },
    //生产专利上传
    beforeUploadfm(file) {
      // 检查文件类型
      if (file.type == "image/jpeg" || file.type == "application/pdf") {
        this.dir = file.type == "image/jpeg" ? "image" : "file";
        let formData = new FormData();
        formData.append("imgFile", file);

        axios
          .post("kindeditor/php/uploadApi.php?mode=3&dir=" + this.dir, formData)
          .then((res) => {
            console.log(res, "res");
            if (res.data.errno == 0) {
              let data = {
                url: res.data.url,
                uid: file.uid,
              };
              this.reportForm.productPatent = [
                ...this.reportForm.productPatent,
                data,
              ];
              this.fmList.push(data.url);
              this.$forceUpdate();
            }
          })
          .catch(function (err) {
            console.log(err);
          });

        return true;
      } else {
        this.$message.error("只能上传 JPEG JPG PNG PDF 格式的图片！");
        return false;
      }
    },

    //历史获奖删除
    handlelshjRemove(file, fileList) {
      this.$confirm(`确认删除文件?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let list = [];
          this.reportForm.historyAward = this.reportForm.historyAward.filter(
            (v) => v.url !== file.url
          );
          this.reportForm.historyAward.map((item) => {
            list.push(item.url);
          });
          this.lsList = list;
        })
        .catch(() => {});
    },
    //历史获奖上传
    beforeUploadls(file) {
      // 检查文件类型
      if (file.type == "image/jpeg" || file.type == "application/pdf") {
        this.dir = file.type == "image/jpeg" ? "image" : "file";
        let formData = new FormData();
        formData.append("imgFile", file);

        axios
          .post("kindeditor/php/uploadApi.php?mode=3&dir=" + this.dir, formData)
          .then((res) => {
            console.log(res, "res");
            if (res.data.errno == 0) {
              let data = {
                url: res.data.url,
                uid: file.uid,
              };
              this.reportForm.historyAward = [
                ...this.reportForm.historyAward,
                data,
              ];
              this.lsList.push(data.url);
              this.$forceUpdate();
            }
          })
          .catch(function (err) {
            console.log(err);
          });

        return true;
      } else {
        this.$message.error("只能上传 JPEG JPG PNG PDF 格式的图片！");
        return false;
      }
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.img-tips {
  color: red;
}

body {
  background: #fff;
}
.content {
  background: #fff;
  margin-right: 40px;
}
/*评奖报名首页*/
.main {
  padding: 30px 0px 30px 40px;
  box-sizing: border-box;
}
.main .title {
  color: #000;
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  font-family: SourceHanSansCN, SourceHanSansCN;
}
.main .dis-notice {
  color: #000;
  padding: 20px;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 22px;
  border-radius: 8px;
  background: #f8f8f8;
  margin: 20px 0 52px;
  font-family: PingFangSC, PingFang SC;
}
.main .dis-notice p {
  max-width: 730px;
}
.main .dis-notice .seek {
  font-size: 16px;
  line-height: 24px;
  padding-top: 15px;
}
.main .dis-list .dis-item {
  width: 44%;
  height: 162px;
  max-width: 510px;
  min-width: 430px;
  margin-right: 30px;
  margin-bottom: 30px;
  background: #f6f7fc;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 31px 20px 20px;
  font-size: 14px;
  color: #000;
  line-height: 20px;
  position: relative;
  font-family: PingFangSC, PingFang SC;
}
.main .dis-list .dis-item-left .dis-title {
  font-size: 24px;
  font-weight: 500;
  line-height: 33px;
}
.main .dis-list .dis-item-left .dis-time {
  font-size: 20px;
  padding: 15px 0;
  line-height: 28px;
}
.main .dis-list .dis-item-left .dis-more a {
  color: #999;
  display: flex;
  align-items: center;
}
.main .dis-list .dis-item-left .dis-more .more-img {
  width: 17px;
}
.main .dis-list .dis-item .sign-tips {
  width: 116px;
  height: 39px;
  color: #ff0000;
  font-size: 18px;
  text-align: center;
  line-height: 39px;
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(
    180deg,
    rgba(255, 0, 0, 0) 0%,
    rgba(255, 0, 0, 0.2) 100%
  );
  border-radius: 8px 8px 8px 26px;
}
.main .dis-list .dis-item-right .dis-btn {
  width: 128px;
  height: 44px;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  line-height: 44px;
  text-align: center;
  background: #fc9749;
  border-radius: 8px;
  border: 1px solid #fc9749;
  font-family: PingFangSC, PingFang SC;
}
.main .dis-list .dis-item-right .dis-ebtn {
  color: #fc9749;
  background: #fff;
  border: 1px solid #fc9749;
}

/*奖项详情*/
.main-details .details-top {
  height: 78px;
  padding: 0 40px;
  font-size: 18px;
  font-family: SourceHanSansCN, SourceHanSansCN;
  color: #000;
  background: #f3f4f8;
}
.main-details .details-top .close-btn {
  width: 130px;
  height: 44px;
  color: #666;
  font-size: 14px;
  line-height: 44px;
  text-align: center;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
}
.main-details .details-title {
  color: #3d83e8;
  font-size: 16px;
  padding-top: 20px;
  line-height: 24px;
  margin-left: 40px;
  padding-bottom: 10px;
  font-family: PingFangSC, PingFang SC;
  border-bottom: 1px solid #3d83e9;
}
.main-details .details-content {
  padding: 20px;
  margin: 20px 40px;
  background: #f8f8f8;
  border-radius: 8px;
}

/*品牌企业奖——信息填写*/
.content_main .content-notice {
  padding: 20px;
  font-size: 14px;
  color: #000;
  line-height: 22px;
  min-height: 106px;
  background: #f8f8f8;
  border-radius: 8px;
  margin-right: 38px;
  margin-bottom: 20px;
  box-sizing: border-box;
  font-family: PingFangSC, PingFang SC;
}
.save_btn .el-button {
  width: 130px;
}

.awards-upload .el-upload--picture-card,
.awards-upload .el-upload--picture-card .upload-tip,
.awards-upload .el-upload-list--picture-card .el-upload-list__item {
  width: 262px;
  height: 128px;
}
.awards-upload .el-upload--picture-card {
  background: #fff;
}
.awards-upload .el-upload--picture-card .upload-tip i {
  padding-top: 20px;
  display: inline-block;
}
.awards-upload .el-upload--picture-card .upload-tip .upload-img {
  width: 34px;
  height: 34px;
  display: block;
  margin: 0 auto 15px;
}
.awards-upload .el-upload--picture-card .upload-tip .tips {
  width: 100%;
  height: 24px;
  color: #000;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
}
.awards-upload .el-upload-list--picture-card .el-upload-list__item {
  position: relative;
}
.awards-upload .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  height: auto;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.pdf_box {
  width: 358px;
  height: 68px;
  background: #ffffff;
  border-radius: 8px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  box-sizing: border-box;
}
.pdf_box img {
  width: 28px;
  height: 28px;
}
.txt_box {
  margin: 0 58px 0 10px;
}
.txt_title {
  width: 173px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 13px;
  color: #000000;
  line-height: 24px;
}
.txt_size {
  width: 39px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 24px;
}
.xz_btn {
  width: 54px;
  height: 26px;
  line-height: 26px;
  background: #e4efff;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #3d83e9;
  text-align: center;
  cursor: pointer;
}

.el-checkbox {
  /*display: flex;*/
  /*align-items: center;*/
}
.el-checkbox__inner {
  width: 26px;
  height: 26px;
}
.el-checkbox__inner::after {
  top: 5px;
  left: 10px;
  height: 9px;
  border-width: 2px;
}
.content_main_title {
  display: flex;
  align-items: center;
}
.edit-wrap {
  width: 56px;
  height: 22px;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  margin-left: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #3d83e8;
  border-radius: 12px;
}
.edit-icon {
  width: 11px;
  position: relative;
  right: auto;
  margin-right: 2px;
  display: inline-block;
}
.adress_box .adress_input .el-input__inner {
  font-weight: bold;
}
.el-upload .avatar {
  position: absolute;
  top: 50%;
  left: 50%;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  transform: translate(-50%, -50%);
}
.el-upload,
.el-upload-list .el-upload-list__item {
  width: 262px;
  height: 128px;
  background: #fff;
  border-radius: 8px;
  position: relative;
  border: 1px dashed #e0e0e0;
}
.header_title {
  font-size: 18px;
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-weight: 400;
}
.header_main {
  background: #f3f4f8;
  padding: 30px 38px;
  box-sizing: border-box;
}
.content_main {
  padding: 30px 0 30px 38px;
  box-sizing: border-box;
}
.content_title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
}
.btn_box {
  margin: 20px 0 30px;
}
.tb_btn {
  display: inline-block;
  width: 130px;
  height: 44px;
  line-height: 44px;
  background: #3d83e9;
  border-radius: 8px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}
.xj_btn {
  display: inline-block;
  width: 130px;
  height: 44px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #3d83e9;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #3d83e9;
  line-height: 44px;
  text-align: center;
  margin-left: 15px;
  cursor: pointer;
}
.cp_list {
  display: flex;
  flex-wrap: wrap;
}
.cp_item {
  position: relative;
  width: 500px;
  /*height: 120px;*/
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  margin-right: 30px;
  padding: 15px;
  box-sizing: border-box;
  margin-bottom: 30px;
  display: flex;
}
.cp_item_img {
  width: 90px;
  height: 90px;
}
.cp_item_bottom {
  display: flex;
}
.cp_item_bottom img {
  width: 28px;
  height: 28px;
  margin-left: 52px;
}
.cp_item_bottom span {
  display: inline-block;
  width: 290px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
  margin-top: 6px;
}
.cp_item_top {
  display: flex;
  align-items: center;
}
.cp_item_top span:nth-child(1) {
  width: 280px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #000000;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.tj {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 12px;

  margin-left: 16px;
}
.wtj {
  color: #ff4d4f !important;
}
.ytj {
  color: #52c41a !important;
}
.txt_content {
  margin-left: 15px;
}
.cp_item_icon {
  position: absolute;
  top: 5px;
  left: 5px;
  width: 60px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  border-radius: 12px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
}
.rw_icon {
  background: #ffcc00;
}
.wrw_icon {
  background: #999999;
}
.cypx {
  width: 68px;
  height: 24px;
  line-height: 24px;
  background: #fc9749;
  border-radius: 4px;
  border: 1px solid #fc9749;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  position: absolute;
  bottom: 10px;
  right: 10px;
  cursor: pointer;
}
.el-pagination {
  text-align: right;
  margin-right: 100px;
}

.header_title {
  font-size: 18px;
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-weight: 400;
  color: #000000;
}
.header_main {
  background: #f3f4f8;
  padding: 30px 38px;
  box-sizing: border-box;
}
.header_step_box {
  display: flex;
  flex-wrap: wrap;
  margin-top: 40px;
}
.step_item {
  display: flex;

  margin-right: 126px;
}
.step_number {
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: #bbbbbb;
  border-radius: 21px;
  font-size: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.step_txt {
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  margin-left: 10px;
}
.step_txt .txt1 {
  color: #000000;
  margin-bottom: 5px;
}
.step_txt .txt2 {
  color: #999999;
}

.content_main {
  padding: 30px 0 30px 38px;
  box-sizing: border-box;
}
.content_main_title {
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #3d83e8;
  padding-bottom: 10px;
  border-bottom: 1px solid #3d83e9;
  margin-bottom: 30px;
}
.save_btn {
  display: flex;
  justify-content: center;
  margin-top: 200px;
}
.step_actitive {
  background: #1677ff !important;
}
.txt_actitive {
  color: #000000 !important;
}
/*图片*/
.tp_update .el-upload-dragger {
  width: 148px !important;
  height: 148px !important;
}
.tp_update .el-upload--picture-card {
  width: 148px !important;
  height: 148px !important;
  /*border: none !important;*/
}
.tp_update .el-icon-tip {
  display: block !important;
  font-size: 16px !important;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 0.88);
  margin-top: 15px;
}
.tp_update .el-upload--picture-card i {
  display: flex;
  flex-direction: column;
  width: 148px !important;
  height: 148px;
  align-items: center;
  justify-content: center;
  font-size: 36px;
}

/*pdf 和 图片*/
.pdf_update .el-upload-dragger {
  width: 262px !important;
  height: 128px !important;
}

.pdf_update .el-upload--picture-card {
  width: 262px !important;
  height: 128px !important;
  border: none !important;
}

.pdf_update .el-upload--picture-card i {
  display: flex;
  flex-direction: column;
  width: 262px !important;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-size: 16px !important;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.88);
  margin-top: 8px;
}
.pdf_update .el-upload--picture-card {
  line-height: 3;
}
.discussion_upload {
  width: 34px;
  height: 32px;
  margin-top: 22px;
}
.zh_tips1 {
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #ff4d4f;
  margin-bottom: 16px;
}

.zh_tips_checkbox span {
  font-size: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #ff4d4f;
}

.discussion_susscess {
  width: 77px;
  height: 77px;
  margin-right: 20px;
}
.susscess_icon_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.susscess_icon_box span {
  font-size: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #000000;
  margin-top: 18px;
}
.susscess_tips {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 960px;
  height: 88px;
  background: rgba(255, 77, 79, 0.08);
  border-radius: 8px;
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #ff4d4f;
  margin: 20px 0;
}
.adress_box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #222222;
}
.adress_input {
  width: 660px;
  /*height: 48px;*/
  background: #edf1f7;
  border-radius: 5px;
}
.fz_btn {
  width: 95px;
  height: 38px;
  line-height: 38px;
  background: #ffffff;
  border-radius: 3px;
  border: 1px solid #3d83e9;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #3c81e6;
  text-align: center;
  margin-left: 30px;
}
a {
  color: #ffffff;
}
.demo-ruleForm .el-form-item {
  padding-right: 30px;
}

.awards-upload .el-upload--picture-card,
.awards-upload .el-upload--picture-card .upload-tip,
.awards-upload .el-upload-list--picture-card .el-upload-list__item {
  width: 262px;
  height: 128px;
}
.awards-upload .el-upload--picture-card {
  background: #fff;
}
.awards-upload .el-upload--picture-card .upload-tip i {
  padding-top: 30px;
  display: inline-block;
}
.awards-upload .el-upload--picture-card .upload-tip .upload-img {
  width: 34px;
  height: 34px;
  display: block;
  margin: 0 auto 15px;
}
.awards-upload .el-upload--picture-card .upload-tip .tips {
  width: 100%;
  height: 24px;
  color: #000;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
}
.awards-upload .el-upload-list--picture-card .el-upload-list__item {
  position: relative;
}
.awards-upload .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.edit-icon {
  width: 35px;
  position: absolute;
  right: 30px;
  z-index: 99;
  cursor: pointer;
}
.image {
  width: 148px;
  height: 148px;
  border-radius: 6px;
  position: relative;
  display: inline-block;
  /deep/ .el-image {
    width: 148px;
    height: 148px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    .el-image__inner {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .upload-span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000, $alpha: 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.1s;
    border-radius: 6px;
    .upload-icon {
      color: #fff;
      font-size: 22px;
    }
  }
  &:hover {
    .upload-span {
      opacity: 1;
    }
  }
}

@media only screen and (max-width: 767px) {
  .el-col-12 {
    width: 100%;
  }
  .el-col-7 {
    width: 100%;
  }
  .el-col-3 {
    width: 100%;
  }
  .el-col-5 {
    width: 100%;
  }
  .content .el-button {
    transform: translateX(0);
    min-width: 120px;
  }
  .step_item {
    margin-right: 0;
    margin-bottom: 10px;
  }
  .content_main {
    padding: 30px 0;
  }
}
</style>
<style >
.el-radio-group {
  font-size: 12px !important;
  line-height: 3 !important;
}
.el-form--label-top .el-form-item__label {
  font-weight: bolder !important;
}
</style>